class FilterOverlay {
	constructor(el) {
		this.el = el
		this.triggerRef = document.querySelectorAll('[data-role="js--filter-overlay-trigger"]')[0]
		this.closeBtn = this.el.querySelectorAll('[data-role="js--filter-overlay-close"]')
		this.submitBtn = this.el.querySelector('[data-role="js--filter-overlay-submit"]')
		this.triggerRef && this.triggerRef.addEventListener('click', this._triggerHandler.bind(this))
		this.closeBtn && this.closeBtn[0].addEventListener('click', this._closeHandler.bind(this))
		this.closeBtn && this.closeBtn[1].addEventListener('click', this._closeHandler.bind(this))
		this.submitBtn && this.submitBtn.addEventListener('click', this._closeHandler.bind(this))
	}
	_triggerHandler(event) {
		this.el.style.display = 'block'
		setTimeout(() => {
			this.el.classList.add('is-active')
		}, 50)
	}
	_closeHandler(event) {
		this.el.classList.remove('is-active')
		setTimeout(() => {
			this.el.style.display = 'none'
		}, 200)
	}
}

export default FilterOverlay
